// --------------------------------------------------------------------------
// The purpose of this component is to expose a generic interface to other
// components that might use it that is independent of a specific scanning
// library (as far as possible).
// Put another way, this component is tightly coupled to the libraries used
// so that components that use it do not have to be.
// --------------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';

// --------------------------------------------------------------------------

import Scanner from './scanner-quagga2.js';

// --------------------------------------------------------------------------

class GenericScanner extends React.Component {

    // ----------------------------------------------------------------------
    // this provides the level above with the results in a standardised form
    // ----------------------------------------------------------------------

    render() {
                   
        return (
        
            <Scanner
                onDetected={ (code) => { this._onDetectedSingle(code);  }  }
                onError={ (err) => { this._onError(err); } }
                useCameraId={ this.props.useCameraId }
                />

        );
    }

    // ----------------------------------------------------------------------

    // for faking scans in testing
    mockTimer = null;
    mockTimeLength = 2000;

    // ----------------------------------------------------------------------

    componentDidMount() {
        // this code exists to allow testing of the UI without need to physically scan something
        let self = this;        
        let qs = window.location.search.split('?fakeScan=');
        let ean = qs.length==2 ? qs[1].split('&')[0] : null;
        if(ean!=null) {
            self.mockTimer = setTimeout(() => {
                self._onDetectedSingle(ean);
            }, this.mockTimeLength);
        }
    }

    // ----------------------------------------------------------------------

    componentWillUnmount() {
        // if faking a scan, clear the timer
        if(this.mockTimer!=null) clearTimeout(this.mockTimer);
    }

    // ----------------------------------------------------------------------

    _onDetectedSingle(code) {

        this.props.onDetected(
            [
                {
                    code: code,
                    confidence: 1.0 // future value
                }
            ]
        );

    }

    // ----------------------------------------------------------------------

    _onError(err) { this.props.onError(err); }

}
// --------------------------------------------------------------------------

GenericScanner.propTypes = {
    onDetected: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired
    // and useCameraId
};

// --------------------------------------------------------------------------
export default GenericScanner;
// --------------------------------------------------------------------------
